import { LitElement, html } from 'lit';
import Styles from './vm-loading-spinner.scss';

export default class VmLoadingSpinner extends LitElement {
    static styles = Styles;

    static properties = {
        size: { type: String },
    };

    constructor() {
        super();
        this.size = '1';
    }

    render() {
        return html`
            <div class="vm-loading-spinner">
                <i class="icon icon-loading-spinner" style="font-size: ${this.size}em;"></i>
            </div>
        `;
    }
}
